<div class='full-form'>
	<!--<h3 *ngIf='datasetRS.record.value && !datasetACS.loading.value' class="addNew">
		Aggiungi servizio o crea nuovo
		<span class="material-icons" matTooltip="Crea servizio" (click)='createNewService()'>add</span>
	</h3>
	<br/>-->
	<language-select 
		[selected]='appService.language.value'
		(changed)='appService.language.next($event)'
		[languageCodes]='appService.supportedLanguageCodes' 
		[activeLanguageCodes]='datasetMCS.activeLanguageCodes'
	></language-select>

	<mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate" *ngIf='datasetACS.loading.value'></mat-progress-bar>

	<div class='mt-24' *ngIf='datasetACS.ready.value'>
		<ng-container *ngIf='!datasetRS.record.value && !datasetACS.loading.value'>
			<p>Questa traduzione non è ancora presente!</p>

			<div class='mt-24 mb-24' fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
				<button mat-flat-button (click)='goPrevStep()'>Indietro</button>
			</div>
		</ng-container>

		<ng-container *ngIf='datasetRS.record.value && datasetRS.record.value["lang"] === appService.language.value'>
			<custom-mat-table
				[relation]='"facilities"'
				[displayedColumns]='displayedColumns'
				[filterFormGroup]='filterFormGroup'
				[field]='field'
				[datasetACS]='parentDatasetACS'
				[datasetRS]='datasetRS'
				[dynamCols]='dynamCols'
				[stepName]='"trip_package_facilities"'
				[datasetCode]='"trip_packages"'
				[datasetConfig]='datasetConfig'
				[formConfigMap]='formConfig'
				(nextStep)='goNextStep()'
				[initialValueKey]='"title"'
			></custom-mat-table>
		</ng-container>
	</div>
</div>